import { AboyeurPluginNamed } from '@ifood/aboyeur';
import Amplitude from 'amplitude-js';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function isBrowser() {
  return Boolean(process.browser);
}

var NAME = 'Amplitude';
var ERROR = {
  CONFIG: "Malconfigured " + NAME + " plugin metadata",
  BROWSER: NAME + " plugin MUST run only in browsers"
};
var MANDATORY_AMPLITUDE_CONFIG_KEYS = ['apiKey', 'version'];

function isAmplitudeMetadata(metadata) {
  if (!('amplitude' in metadata)) {
    return false;
  }

  var amplitude = metadata.amplitude;

  if (typeof amplitude !== 'object' || !amplitude) {
    return false;
  }

  return MANDATORY_AMPLITUDE_CONFIG_KEYS.every(function (key) {
    return Object.prototype.hasOwnProperty.call(amplitude, key);
  });
}

var AmplitudePlugin = /*#__PURE__*/function (_AboyeurPluginNamed) {
  _inheritsLoose(AmplitudePlugin, _AboyeurPluginNamed);

  function AmplitudePlugin() {
    return _AboyeurPluginNamed.apply(this, arguments) || this;
  }

  var _proto = AmplitudePlugin.prototype;

  _proto.initialize = function initialize() {
    var metadata = this.metadata;

    if (!isAmplitudeMetadata(metadata)) {
      throw new Error(ERROR.CONFIG);
    }

    if (!isBrowser()) {
      throw new Error(ERROR.BROWSER);
    }

    var amplitude = Amplitude;
    var _metadata$amplitude = metadata.amplitude,
        apiKey = _metadata$amplitude.apiKey,
        version = _metadata$amplitude.version,
        userId = _metadata$amplitude.userId,
        clientConfig = _metadata$amplitude.clientConfig;
    this.instance = amplitude.getInstance();
    this.instance.init(apiKey, userId, clientConfig);
    this.instance.setVersionName(version);
  };

  _proto.sendEvent = function sendEvent(options) {
    var _this$instance;

    var label = options.label,
        entity = options.entity,
        feature = options.feature,
        metadata = options.metadata;

    var event = _extends({}, metadata.instance, metadata.event, {
      entity: entity,
      feature: feature
    });

    (_this$instance = this.instance) == null ? void 0 : _this$instance.logEvent(label, event);
  };

  _proto.onMetadataChange = function onMetadataChange() {
    if (!this.instance) {
      return;
    }

    if (!isAmplitudeMetadata(this.metadata)) {
      return;
    }

    var _this$metadata$amplit = this.metadata.amplitude,
        userId = _this$metadata$amplit.userId,
        version = _this$metadata$amplit.version,
        user = _this$metadata$amplit.user;

    if (userId) {
      this.instance.setUserId(userId || null);
    }

    if (version) {
      this.instance.setVersionName(version);
    }

    if (!user) {
      return;
    }

    if (!isBrowser()) {
      throw new Error(ERROR.BROWSER);
    }

    var amplitude = Amplitude;
    var userIdentify = new amplitude.Identify();
    Object.entries(user).forEach(function (_ref) {
      var key = _ref[0],
          value = _ref[1];
      userIdentify.set(key, String(value));
    });
    this.instance.identify(userIdentify);
  };

  return AmplitudePlugin;
}( /*#__PURE__*/AboyeurPluginNamed(NAME));

export { AmplitudePlugin };
//# sourceMappingURL=aboyeur-plugin-amplitude.esm.js.map
